import {AutomationExecution} from 'crqlar-react-common/dist/models/automation/automation';
import {AutomationService} from 'crqlar-react-common/dist/services/automation/AutomationService';

const MEMBER_RUNS_PAGE_SIZE = 100;

/** Pages through every member run: a live fan-out has no cap (an audience of 349 is 349 runs). */
export const loadMemberRuns = async (parentId: string): Promise<AutomationExecution[]> => {
    const runs: AutomationExecution[] = [];
    let pageNumber = 0;
    let totalPages = 1;
    do {
        const page = await AutomationService.getExecutions({
            parentExecutionId: parentId,
            page: pageNumber,
            pageSize: MEMBER_RUNS_PAGE_SIZE,
            sortBy: 'insertDate',
            sortDir: 'ASC'
        });
        runs.push(...(page.content ?? []));
        totalPages = page.totalPages ?? 1;
        pageNumber++;
    } while (pageNumber < totalPages);

    return runs;
};
